const INITIAL_STATE = {
    customers: null,
    error: null,
    loading: false
};

export default function(state = INITIAL_STATE, action) {
    let error;
    switch(action.type) {

    case "FETCH_CUSTOMERS":
        return { ...state, searchKey: action.payload, customers: [], error: null, loading: true, loaded: false };
    case "FETCH_CUSTOMERS_SUCCESS":
        return { ...state, paging: action.payload, customers: action.payload.content, error:null, loading: false, loaded: true };
    case "FETCH_CUSTOMERS_FAILURE":
        error = action.payload || {message: action.payload.message};
        return { ...state, customers: [], error: error, loading: false, loaded: true };

   default:
        return state;
    }
};


// WEBPACK FOOTER //
// ./src/store/reducers/customers.js